import React from 'react';

import styles from './index.module.scss';
import JoinOurCommunity from '../TippingArticles/JoinOurCommunity';
import { Link } from 'react-router-dom';

const textContent = [
  {
    key: '1',
    textTitle: `I. COMPANY’S SERVICES; FEES.`,
    content: (
      <>
        1.1 The Company will provide User the Services requested in accordance
        with this Agreement, enabling Users to, e.g., receive and post content
        and create an account (“User Account”) on the Platform to access,
        submit, and receive, e.g., documents, information, and services.
        <br />
        <br />
        1.2 Unless otherwise noted on the Platform, the Services and the User
        Account are currently free to Users, but (a) the Company, in its sole
        discretion, may implement, increase, or decrease applicable costs and
        fees for the Services (the “Fees”), which the User may choose to accept
        by signing up for and/or paying for such applicable services; and (b)
        the Company may link to, e.g., third-party sites and informational
        articles for which it may earn referral fees or a commission.
      </>
    ),
  },
  {
    key: '2',
    textTitle: `II. USER WARRANTIES.`,
    content: (
      <>
        2.1 By using the Services and/or accessing the Platform, the User
        warrants: (a) that the User is at least 18 years of age; (b) that the
        User has read and understood these Terms of Service; and (c) that the
        User agrees to be bound by the terms and obligations of these Terms of
        Service and the Privacy Policy, respectively.
      </>
    ),
  },
  {
    key: '3',
    textTitle: `III. USER DISCLOSURE OF DATA; COMPANY’S PRIVACY POLICY.`,
    content: (
      <>
        3.1 Company will use reasonable endeavors to hold all personal
        information submitted by the User or provided to Company under this
        Agreement in strict confidence; provided, however, that Company will not
        be held liable, without limitation, if such data is released (i) through
        other sources, (ii) because of a reasonable belief that User has
        consented to such disclosure, (iii) if compelled by regulatory or court
        order; or (iv) in accordance with the Agreement.
        <br />
        <br />
        3.2 Company’s Privacy Policy details how Company collects, uses, stores,
        and discloses, e.g., personal information from Users. User acknowledges
        and understands that Company may collect, use, store, and disclose
        User’s information pursuant to Company’s Privacy Policy, as it may be
        updated from time to time, in order to provide the Services and operate
        the Platform. By using the Platform or the Services, you are explicitly
        agreeing to both these Terms of Service and the Privacy Policy,
        respectively, so you are strongly encouraged to review the Company’s
        Privacy Policy in full, which can be accessed at{' '}
        <a href="/privacy-policy">Privacy Policy</a>.
      </>
    ),
  },
  {
    key: '4',
    textTitle: `IV. PROPRIETARY RIGHTS.`,
    content: (
      <>
        4.1 To access the Services, Users may need to create an account on the
        Platform. <strong>“User Content”</strong> means any text, graphics,
        images, software, audio, video, works of authorship of any kind, and
        documents, information, or other materials that are uploaded to, posted
        to, stored on, or created using the Platform by Users. For the avoidance
        of doubt, any templates, documents, or materials that Company provides
        to User via the Services shall constitute{' '}
        <strong>“Company Content”</strong>
        (as defined below) hereunder. Company does not claim any ownership
        rights in any User Content, and nothing in this Agreement will be deemed
        to restrict any rights that User may have to use and exploit User
        Content. However, by making any User Content available through the
        Platform, User hereby grants to Company a non-exclusive, transferable,
        sublicensable, worldwide, royalty-free license to use, copy, modify,
        create derivative works based upon, publicly display, publicly perform,
        and distribute User Content in connection with operating and providing
        the Platform and the Services. User is solely responsible for all User
        Content. User represents and warrants that User owns all User Content or
        User has all rights that are necessary to grant Company the
        aforementioned license rights in User Content under this Agreement and
        that User Content does not infringe upon the intellectual property
        rights of any third party. The User further warrants that all User
        Content is accurate, up-to-date, and not misleading.
        <br />
        <br />
        4.2 User may generally remove or delete User Content from the Platform,
        provided that certain types of User Content may not be removed from the
        Platform to comply with Company’s regulatory or legal obligations.
        Moreover, in certain instances, some User Content may not be completely
        removed, and copies of User Content may continue to exist on the
        Platform. Company is not responsible or liable for the removal or
        deletion of (or the failure to remove or delete) any User Content.{' '}
        <br />
        <br />
        4.3 <strong>“Company Content”</strong> means text, graphics, images,
        music, software, audio, video, works of authorship of any kind, and
        documents, information, or other materials that are posted, generated,
        provided, or otherwise made available through the Services or Platform
        by Company, other than User Content. User Content and Company Content
        shall be collectively referred to herein as <strong>“Content”</strong>.
        Company, its affiliates, partners, or its licensors exclusively own all
        worldwide right, title, and interest in and to the Company Content, and
        also in and to the Platform and the Services, including, in each case,
        all associated intellectual property rights
        <strong>(“Company IP”)</strong>. User acknowledges that the Platform,
        Services, and Company Content are protected by copyright, trademark, and
        other laws of the United States and/or foreign countries. User agrees
        not to remove, alter, or obscure any copyright, trademark, service mark,
        or other proprietary rights notices incorporated in or accompanying the
        Platform, Services, or Company Content. This Agreement does not convey
        any proprietary interest in or to any Company IP or rights of
        entitlement to the use thereof except as expressly set forth herein. Any
        feedback, comments, and suggestions User may provide for improvements to
        the Platform, Services, or Company Content <strong>(“Feedback”)</strong>{' '}
        is given voluntarily, and Company will be free to use, disclose,
        reproduce, license, or otherwise distribute and exploit such Feedback as
        it sees fit, entirely without obligation or restriction of any kind.
        Feedback includes, without limitation, feedback that User provides to
        Company in response to any surveys Company conducts, through any
        available technology, about User’s experiences with, e.g., Company, the
        Services, the Platform, etc.
        <br />
        <br />
        4.4 Subject to User’s compliance with this Agreement, Company grants
        User a limited, non- exclusive, non-transferable, non-sublicensable
        license to access, view, and download Company Content solely in
        connection with User’s permitted use of the Platform and/or Services.
      </>
    ),
  },
  {
    key: '5',
    textTitle: `V. THIRD-PARTY SERVICES.`,
    content: (
      <>
        5.1 Through the Platform, User may be able to receive services from
        partners, affiliates, or other third-parties of Company (each such
        service, a <strong>“Third-Party Service”</strong> and each such partner,
        a<strong>“Partner”</strong>). User is solely responsible for, and
        assumes all risk arising from, User’s election to receive and User’s
        receipt of any Third-Party Service. Company is not responsible for
        Third- Party Services, or any material, information, or results made
        available through Third-Party Services. The applicable Partners may
        require User to agree to terms and conditions or agreements with respect
        to their provision of the Third-Party Services to User. Company reserves
        the right to terminate this Agreement and the provision of Services in
        the event User breaches the terms of its agreement with any Partner.
        <br />
        <br />
        5.2 If User elects to receive a Third-Party Service, User authorizes
        Company to submit to the applicable Partner any and all documents and
        information about User that are necessary for such Partner to provide
        the Third-Party Service to User (collectively, the{' '}
        <strong>“Shared Information”</strong>). User is responsible for the
        accuracy of all Shared Information. User represents and warrants that
        User has all the rights in and to any Shared Information necessary to
        provide Shared Information to Company and for Company to provide it to
        Partners, and that Company’s use or disclosure of Shared Information as
        contemplated hereunder will not violate any rights of privacy or other
        proprietary rights, or any applicable local, state, or federal laws,
        regulations, orders, or rules.
        <br />
        <br />
        User agrees that by electing to receive a Third-Party Service, and by
        consenting and authorizing Company to submit User’s Shared Information
        to a Partner, User has waived and released any and all liabilities,
        claims, demands, damages, losses, fines, judgments, disputes, costs,
        charges and expenses (each and collectively a <strong>
          “Claim”
        </strong>{' '}
        or <strong>“Claims”</strong>) against Company and its directors,
        officers, agents, contractors, and employees arising out of a Partner’s
        use of User’s Shared Information, even if that use is not authorized by
        the applicable agreement between User and the Partner.
      </>
    ),
  },
  {
    key: '6',
    textTitle: `VI. TERMINATION.`,
    content: (
      <>
        6.1 The Services and this Agreement will continue until they are
        terminated by either party. User may terminate the Services and this
        Agreement through User’s Account, or as otherwise made available by
        Company via termination/cancellation form or in writing. Company may
        terminate the Services and this Agreement by giving User written notice
        (e-mail sufficient).
        <br />
        <br />
        6.2 In addition to Company’s foregoing termination right, Company may
        immediately suspend or restrict User’s Account; suspend or restrict
        User’s access to the Platform or any Services; block User’s ability to
        use any particular feature of a Service; or immediately terminate the
        Services and this Agreement, in each case with or without notice to
        User, in the event that: (i) Company has any reason to suspect or
        believe that User, whether directly or indirectly, may be in violation
        of this Agreement or User’s agreement with any Partner; (ii) Company
        determines that User’s actions are likely to cause legal liability for
        or material negative impact to the Company; (iii) Company believes that
        User has misrepresented any data or information or that User has engaged
        in fraudulent or deceptive practices or illegal activities; or (iv) User
        files a petition under the U.S. Bankruptcy Code or a similar state or
        federal law, or a petition under the U.S. Bankruptcy Code or a similar
        state or federal law is filed against User.
        <br />
        <br />
        6.3 The termination of any of the Services or this Agreement will not
        affect User’s or Company’s rights with respect to transactions which
        occurred before termination. Company will have no liability for any
        costs, losses, damages, penalties, fines, expenses, or liabilities
        arising out of or related to Company’s termination of this Agreement.
        Any sections of this Agreement, which by their nature should survive,
        will survive and remain in effect even if this Agreement is terminated,
        canceled, or rescinded. <br />
        <br />
        6.4 Upon termination of any of the Service(s) and/or termination of this
        Agreement, User’s right to access and use such terminated Services(s)
        will automatically terminate; provided, however, that Company, in its
        sole discretion, and for a limited time, may continue to provide User
        with the ability to access User’s Account in a limited capacity with
        respect to such terminated Service(s) to view and download information
        that was available in User’s Account at the time of termination of such
        Service(s) (the <strong>“Limited Access Rights”</strong>). While User
        has Limited Access Rights, User shall use reasonable efforts to
        adequately secure, and keep confidential, any passwords or credentials
        for User’s Account, and any information accessible via User’s Account,
        and User is further encouraged to immediately download any User Content
        or documents or information belonging to User that User wishes to
        retain. Company may deny the Limited Access Rights to User, or Company
        may revoke the Limited Access Rights at any time, in its sole
        discretion. Company shall otherwise retain or destroy, in its sole
        discretion, but consistent with applicable law, User’s personal
        information, as applicable, with additional information on this topic
        found in Company’s Privacy Policy.
      </>
    ),
  },
  {
    key: '7',
    textTitle: `VII. GOVERNING LAW; ARBITRATION.`,
    content: (
      <>
        7.1 This Agreement shall be governed by the laws of the State of
        Colorado, without regard to its conflict of laws principles. Any dispute
        or claim arising out of or in connection with this Agreement, including
        any question regarding its existence, validity, or termination, shall be
        settled by binding arbitration in front of one (1) arbitrator in Denver,
        Colorado, using the American Arbitration Association (AAA). Such
        arbitration shall be conducted in English, and each party, respectively,
        explicitly agrees to personal jurisdiction in and the exclusivity of
        such venue. Such arbitration shall be binding, the arbitrator shall
        provide written details of such ruling, and the prevailing party shall
        be entitled to enforce such judgment in any court of competent
        jurisdiction.
        <br />
        <br />
        7.2 User agrees that by using and/or accessing the Services or Platform,
        (a) User, pursuant to the arbitration provision herein, waives their
        right to a jury trial; (b) agrees that such arbitration is User’s sole
        venue for any claims or damages hereunder; and (c) that User may not
        combine their claims or causes of action with any other user to, without
        limitation, create a class action lawsuit or any similar joint or
        combined action with any third party.
        <br />
        <br />
        7.3 User acknowledges that any breach of this Agreement shall give rise
        to irreparable injury to Company which may not be adequately compensated
        by damages. Accordingly, Company may seek and obtain injunctive relief
        against the breach or threatened breach of the undertakings contained
        herein, in addition to any other legal remedies which may be available,
        without the requirement of posting bond. User further acknowledges and
        agrees that the covenants contained herein are necessary for the
        protection of Company’s legitimate business interests and are reasonable
        in scope and content.
      </>
    ),
  },
  {
    key: '8',
    textTitle: `VIII. GENERAL PROHIBITIONS.`,
    content: (
      <>
        8.1 User explicitly agrees not to take any of the following actions:
        <br />
        <br />
        (a) Post, upload, publish, submit, share, distribute, or transmit any
        User Content that: (i) User lacks the authority to post, upload,
        publish, submit, share, distribute, or transmit; (ii) infringes,
        misappropriates, or violates a third party’s patent, copyright,
        trademark, trade secret, moral rights, or other intellectual property
        rights, or rights of publicity or privacy; (iii) violates, or encourages
        any conduct that would violate, any applicable law or regulation or
        would give rise to civil liability; (iv) is fraudulent, false,
        misleading, or deceptive; (v) is defamatory, indecent, obscene,
        pornographic, vulgar, or offensive; (vi) promotes discrimination,
        bigotry, racism, hatred, harassment, or harm against any individual or
        group; (vii) is violent or threatening or promotes violence or actions
        that are threatening to any person or entity; (viii) promotes illegal or
        harmful activities or substances; or (ix) contains software viruses,
        worms, defects, Trojans, adware, spyware, malware, or other similar
        computer code, files, or programs designed to interrupt, destroy, or
        limit the functionality of any computer software or hardware device;
        <br />
        <br />
        (b) Use the Services other than as authorized in this Agreement;
        <br />
        <br />
        (c) Resell, sub-license, or otherwise share the Services with any third
        party, except as explicitly permitted herein;
        <br />
        <br />
        (d) Display, mirror, or frame (i) the Platform; (ii) the Services; or
        (iii) Content or any individual element within the Platform or Services,
        including Company’s name and any Company trademark, logo, or other
        proprietary information, in each case, without Company’s express prior
        written consent;
        <br />
        <br />
        (e) Access, tamper with, or use non-public areas of the Platform or the
        Services;
        <br />
        <br />
        (f) Attempt to probe, scan, or test the vulnerability of any Company
        system or network or breach any security or authentication measures;
        <br />
        <br />
        (g) Avoid, bypass, remove, deactivate, impair, descramble, or otherwise
        circumvent any technological measure implemented by Company, any of
        Company’s providers, or any other third party (including another User)
        to protect the Platform, Services, or Content;
        <br />
        <br />
        (h) Send any unsolicited or unauthorized advertising, promotional
        materials, email, junk mail, spam, chain letters, or other form of
        solicitation through the Platform or Services;
        <br />
        <br />
        (i) Use the Platform, Services, or Content, or any portion thereof, (i)
        for any purpose other than User’s purposes, or (ii) for the benefit of
        any third party or in any manner not permitted by this Agreement;
        <br />
        <br />
        (j) Attempt to decipher, decompile, disassemble, reverse engineer, or
        otherwise attempt to derive any source code, or underlying ideas, or
        algorithms of any of the software used to provide the Platform,
        Services, or Content;
        <br />
        <br />
        (k) Modify, translate, or otherwise create derivative works of any part
        of the Platform, Services, or Content other than User’s own User
        Content;
        <br />
        <br />
        (l) Interfere with, or attempt to interfere with, the access of any
        User, host, or network, or use any device, software, or routine that is
        intended to damage, surreptitiously intercept, or expropriate any
        system, data, or communication, including, without limitation, by
        sending a virus, overloading, flooding, spamming, or mail-bombing the
        Platform or Services;
        <br />
        <br />
        (m) Impersonate or misrepresent User’s affiliation with any person or
        entity; and
        <br />
        <br />
        (n) Engage in any fraudulent, deceptive, or illegal practices or
        activities, or use the Services to directly or indirectly support any
        such practices or activities;
        <br />
        <br />
        8.2 Company reserves the right to immediately remove any User Content
        that the Company reasonably believes to be in violation of this
        Agreement, and to take such other steps as it deems necessary for any
        material breaches of this Agreement, including terminating this
        Agreement, suspending User’s use of the Platform and the Services, and
        notifying the relevant authorities.
        <br />
        <br />
        8.3 The Company invites the User to report any suspected abuse of the
        Platform or any suspected violation of this Agreement to it at
        <a href="mailto:Support@TippingGuide.com"> Support@TippingGuide.com</a>.
      </>
    ),
  },
  {
    key: '9',
    textTitle: `IX. INDEMNIFICATION; LIMITATION OF LIABILITY; DISCLAIMERS.`,
    content: (
      <>
        9.1 User agrees to indemnify, defend, and hold Company and its agents,
        contractors, partners, and affiliates, including its and their
        respective directors, officers, employees, agents, and contractors
        (each, an “Indemnified Party”), harmless against all Claims made by User
        or any other third party resulting from, arising out of, or related to
        Company’s or any other Indemnified Party’s provision of the Service or
        Platform, reliance on information and data furnished by User, or
        resulting from activities that Company or any other Indemnified Party
        undertakes at User’s request, or at the request of anyone Company or any
        other Indemnified Party believes in good faith to be an authorized agent
        of User, including, without limitation, costs, reasonable attorneys’
        fees, and expert witnesses’ fees incurred in connection with such
        Claims. User agrees that neither Company nor any other Indemnified Party
        will be liable for any loss or damage caused by Company’s or any other
        Indemnified Party’s delay in furnishing, or inability to furnish, the
        Services or the Platform.
        <br />
        <br />
        9.2 In no event will Company’s, or any other Indemnified Party’s,
        liability for any act or omission relating to the Services exceed the
        total charge for services actually incurred by the User and paid to
        Company hereunder.
        <br />
        <br />
        9.3 TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL
        COMPANY OR ANY OTHER INDEMNIFIED PARTY HAVE LIABILITY FOR ANY
        CONSEQUENTIAL, SPECIAL, PUNITIVE, OR INDIRECT LOSS OR DAMAGES, INCLUDING
        PERSONAL INJURY TO USER AND ANY LOSSES OR DAMAGES SUFFERED BY USER AS A
        RESULT OF SUCH PERSONAL INJURY, REGARDLESS OF WHETHER SUCH DAMAGES ARE
        BASED ON CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, OR ANY
        OTHER THEORY OR FORM OF ACTION OR WHETHER COMPANY OR ANY OTHER
        INDEMNIFIED PARTY KNEW OR SHOULD HAVE KNOWN OF THE LIKELIHOOD OF SUCH
        DAMAGES IN ANY CIRCUMSTANCES. USER ACKNOWLEDGES THAT NEITHER COMPANY NOR
        ANY OTHER INDEMNIFIED PARTY MAKES ANY WARRANTIES, EXPRESS OR IMPLIED,
        WITH RESPECT TO THE SERVICES, THE PLATFORM, OR ANYTHING USED IN
        CONNECTION WITH THEREWITH, INCLUDING, WITHOUT LIMITATION, THE WARRANTIES
        OF MERCHANTABILITY AND OF FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND
        NON-INFRINGEMENT.
      </>
    ),
  },
  {
    key: '10',
    textTitle: `X. MISCELLANEOUS TERMS.`,
    content: (
      <>
        10.1 <u>Amendments.</u> Company reserves the right to change the terms,
        conditions, and Fees for the Platform, Services, these Terms of Service,
        and the Privacy Policy at any time and in its sole discretion. User is
        responsible for checking, and explicitly agrees to periodically check,
        the Agreement from time to time for any changes to the Agreement.
        Company will endeavor, but shall not be obligated, to provide thirty
        (30) days’ prior notice of any material change. Notice may be provided
        in writing, electronically (including e-mail), or via the Platform. If
        User does not wish to be bound by such change, User must discontinue
        using and terminate the Services and Platform before the change becomes
        effective. If User continues to use the Services or Platform after the
        change becomes effective, User will be bound by the change(s). User has
        the responsibility to ensure that User’s address, including any
        electronic address(es), billing, and account information in Company’s
        records is accurate. The timing of an advance notice of change may be
        shortened when permitted or required by law.
        <br />
        <br />
        10.2 <u>Entire Agreement.</u> This Agreement contains the entire
        understanding between Company and User concerning the matters addressed
        herein.
        <br />
        <br />
        10.3 <u>No Waiver.</u> No waiver on behalf of any party of any breach of
        the provisions of this Agreement shall be effective or binding upon such
        party unless the same shall be expressed in writing and any waiver so
        expressed shall not limit or affect such party’s rights with respect to
        any future breach of any of the provisions of this Agreement. No failure
        on the part of any party to exercise, and no delay in exercising, any
        right under this Agreement shall operate as a waiver of such right. No
        single or partial exercise of any such right shall preclude any other or
        further exercise of such right or the exercise of any other right.
        <br />
        <br />
        <u>10.4 Independent Contractors.</u> Company is an independent
        contractor with respect to the provision of the Services, and each Party
        is solely responsible for its respective taxes hereunder, as applicable.
        Company and User both specifically and expressly disclaim any intention
        to create a partnership or joint venture or to constitute any party as
        agent of the other. Nothing in the Agreement will result in a party
        being a partner of the other party nor impose any partnership
        obligations on any party. Additionally, nothing in the Agreement shall
        give User the ability to act on behalf of or bind Company.
        <br />
        <br />
        <u>10.5 Severability.</u> Should any section, sub-section, provision, or
        clause of the Agreement be deemed, for any reason whatsoever, to be
        invalid or inoperative, said section, sub-section, provision, or clause
        shall be deemed severable and shall not affect the force and validity of
        any other provisions of this Agreement. Moreover, the section,
        sub-section, provision, or clause deemed invalid or inoperative shall be
        amended by the court or arbitrator, as applicable, to achieve as close
        to the Parties’ intent as possible. <br />
        <br />
        10.6 <u>No Third-Party Beneficiaries.</u> Nothing in this Agreement is
        intended, nor will be deemed, to confer rights or remedies upon any
        person or legal entity not a party to this Agreement.
        <br />
        <br />
        <u>10.7 Assignment.</u> User shall not assign this Agreement without the
        prior written consent of Company. The provisions of this Agreement shall
        inure to the benefit of, and be binding upon, the parties and their
        respective successors and permitted assigns. Company may assign this
        Agreement at any time in its sole discretion, including as a result of
        any sale, merger, consolidation, or asset sale with or to any third
        party.
        <br />
        <br />
        <u>10.8 Survival.</u> The parties’ respective obligations hereunder that
        would require their surviving this Agreement in order to give them full
        force and effect shall survive the termination of this Agreement,
        regardless of the date, cause, or manner of such termination.
      </>
    ),
  },
  {
    key: '11',
    textTitle: `XI. ELECTRONIC SIGNATURE.`,
    content: (
      <>
        By selecting the “I Accept” button or by otherwise using the Services or
        Platform, User signs this Agreement electronically and agrees that
        User’s electronic signature is the legal equivalent of its ink signature
        on this Agreement. By selecting “I Accept'' or by otherwise using the
        Services or Platform, User further represents that it is authorized to
        enter into this Agreement, whether individually or on behalf of a third
        party, and User, including all associated and bound third parties,
        consents to be legally bound by the Agreement and its terms and
        conditions. User further agrees that its use of a keypad, mouse, or
        other device to select an item, button, icon, or similar act/action, or
        to otherwise provide Company with instructions electronically, or making
        any acceptance of any agreement, acknowledgement, consent terms,
        disclosures, or conditions constitutes its signature (hereinafter
        referred to as <strong>“E-Signature”</strong>), acceptance, and
        agreement as if actually signed by User in writing. User also agrees
        that no certification authority or other third-party verification is
        necessary to validate its E-Signature and that the lack of such
        certification or third-party verification will not in any way affect the
        enforceability of its E- Signature or any resulting contract between
        User and Company.
      </>
    ),
  },
  {
    key: '12',
    textTitle: `XII. QUESTIONS; SUPPORT.`,
    content: (
      <>
        12.1 For any questions or support regarding this Agreement, the
        Services, or Platform, please contact the Company at{' '}
        <a href="mailto:Legal@TippingGuide.com">Legal@TippingGuide.com</a>.
        Please include as much specificity as possible in your comment, and
        please allow the Company time to process such comments.
      </>
    ),
  },
];

export default function TermsAndConditionsContent(): React.ReactElement {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.content}>
            <h2>Tipping Guide LLC - Terms of Service</h2>
            <span style={{ fontWeight: 300 }}>
              Last Updated: March 19, 2025 <br />
              <br />
              These Terms of Service (the <strong>“Terms of Service”</strong>),
              along with the Privacy Policy located at{' '}
              <Link to={'/privacy-policy'}>(“Privacy Policy”)</Link>
              (collectively, the <strong>“Agreement”</strong>), contain the
              terms and conditions that govern your use of, without limitation,
              Tipping Guide LLC’s (<strong>“Tipping Guide”</strong>,{' '}
              <strong>“Company”</strong>, <strong>“we”</strong>,{' '}
              <strong>“us”</strong>, or <strong>“our”</strong>) website, mobile
              applications, social media pages, marketing activities, and other
              activities (collectively, the <strong>“Platform”</strong>) and
              services that we offer both on and off the Platform (collectively,
              the <strong>“Services”</strong>).
              <br />
              <br /> This Agreement is applicable to all persons who use or
              access the Platform and/or the Services, whether in their
              individual capacity, as part of or on behalf of an entity, or on
              behalf of any third party (each and collectively, the{' '}
              <strong>“User(s)”</strong>). If the User is agreeing to these
              terms on behalf of an entity, third-party, or an individual other
              than User, User represents and warrants that User has authority to
              bind that entity, third-party, or other individual to this
              Agreement, and User’s agreement to these terms will be treated as
              the agreement of such entity, third-party, or individual. In that
              event, “User”, herein, also refers to that entity, third-party, or
              individual. By clicking the applicable button to indicate User’s
              acceptance of this Agreement (if available), or by accessing or
              using the Platform or Services, User agrees, effective as of the
              date of such action, to be bound by the Agreement.
            </span>
            <ul>
              {textContent.map((item) => (
                <li className={styles.subTitle} key={item.key}>
                  <p>
                    <strong>{item.textTitle}</strong>
                  </p>
                  <div className={styles.text}>
                    <span className={styles.text}>{item.content}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <JoinOurCommunity />
    </>
  );
}
